import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import 'react-multi-carousel/lib/styles.css';
import {ID_PRODUCT_DETAIL_PATH, PRODUCT_DETAIL_PATH, PRODUCTS_LINE_PATH} from "../routes";
import {observer} from "mobx-react";
import {Skeleton} from "@mui/material";
import {useApplication} from "../ApplicationProvider";
import useFeature from "../useFeature";
import {SelectDeliveryPointFeature} from "../functionalities/products/detail/SelectDeliveryPointFeature";
import AddProductToCartButton from "../functionalities/products/detail/AddProductToCartButton";

const HomeContent = ({overdueBalance, initialOrder, productsLines, products, suggestedProducts, feature}) => {
    // useEffect(() => {
    //     const overdueBalance = false
    //     if (overdueBalance) {
    //         Swal.fire({
    //             title: 'Saldo vencido',
    //             text: `Hola ${initialOrder.UsuarioCliente.Nombre}, aun no registramos el pago de tus facturas vencidas, recorda que podes revisar tu Cuenta Corriente`,
    //             icon: 'warning',
    //             showCancelButton: true,
    //             confirmButtonText: 'Revisar',
    //             cancelButtonText: 'Ahora no',
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 window.location.assign('/Frontend/CuentaCorriente');
    //             }
    //         });
    //     }
    // }, []);

    const navigator = useNavigate();
    const application = useApplication();
    const deliverySiteFeature = useFeature(() => new SelectDeliveryPointFeature(application));
    const canAddProducts = feature.canAddProduct();

    const renderFamilias = () => {
        return productsLines.slice().sort((a, b) => a.Nombre.localeCompare(b.Nombre)).map(item => (
            <div className="col-xs-12 col-sm-6 col-md-4" key={item.Id}>
                <Link to={PRODUCTS_LINE_PATH + `/${item.Id}`}>
                    <div className="categories-box">
                        <div className="img-producto-familia-box">
                            <img src={item.ImagenFamilia} className="img-responsive img-producto-familia"
                                 alt={item.Nombre}/>
                        </div>
                        <img src={item.ImagenLogoFamilia} className="img-responsive img-logo-categories"
                             alt={item.Nombre}/>
                        <div>
                            <Link to={PRODUCTS_LINE_PATH + `/${item.Id}`}
                                  className="btn btn-primary btn-sm btn-outlined inline-block margintop30">
                                Ver Productos
                            </Link>
                        </div>
                    </div>
                </Link>
            </div>
        ));
    };

    const renderRecomendados = () => {
        return suggestedProducts.filter(x => !x.EsDemo && x.Producto).map(item => (
            <div className="relative product-item" key={item.Id}>
                <Link to={ID_PRODUCT_DETAIL_PATH} className="img-box">
                    <img src={item.Producto.ImagenProducto} className="img-responsive img-producto-categoria"
                         alt="Foto de Categoría"/>
                </Link>
                <div className="footer-product">
                    <Link to={ID_PRODUCT_DETAIL_PATH}
                          className="h5 title-product show">{item.Producto.Nombre}</Link>
                    <p className="h3 none">$ <span id="precio-producto">XX,XX</span></p>
                    {feature.canAddProduct() &&
                        <Link to={ID_PRODUCT_DETAIL_PATH}
                              className="btn btn-primary btn-sm btn-outlined">Añadir</Link>
                    }
                </div>
            </div>
        ));
    };

    const responsive = {
        superLargeDesktop: {
            breakpoint: {max: 4000, min: 3000},
            items: 5
        },
        desktop: {
            breakpoint: {max: 3000, min: 1024},
            items: 3
        },
        tablet: {
            breakpoint: {max: 1024, min: 464},
            items: 2
        },
        mobile: {
            breakpoint: {max: 464, min: 0},
            items: 1
        }
    };
    return (
        <div>
            {products.length === 0 ? (
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="our-selections">
                                    <Skeleton variant="text" width="80%" height={40} />
                                </div>
                            </div>
                        </div>
                        <div className="row margintop60">
                            {Array.from({ length: 6 }).map((_, index) => (
                                <div className="col-xs-12 col-sm-6 col-md-4" key={index}>
                                    <div className="product-item relative">
                                        <Skeleton variant="rectangular" width="100%" height={200} />
                                        <div className="footer-product">
                                            <Skeleton variant="text" width="80%" />
                                            <Skeleton variant="text" width="60%" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (products.length > 15 ? (
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="our-selections">
                                    <h3>Explora nuestras selecciones</h3>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-10 col-sm-offset-1 col-md-12 col-md-offset-0">
                                <div className="row box-home-categories">
                                    {renderFamilias()}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<hr className="divider-line hidden-xs"/>*/}
                    {/*<div className="container hidden-xs">*/}
                    {/*    <div className="row">*/}
                    {/*        <div className="col-xs-12">*/}
                    {/*            <div className="text-center">*/}
                    {/*                <h3>Productos destacados</h3>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="row margintop50">*/}
                    {/*        <div className="col-xs-12">*/}
                    {/*            <Carousel responsive={responsive} showDots={false} autoPlay={true} autoPlaySpeed={3000}*/}
                    {/*                      infinite={true}>*/}
                    {/*                {renderRecomendados()}*/}
                    {/*            </Carousel>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    {initialOrder.VerModalMultiplePuntoEntrega && (*/}
                    {/*        <div className="row margintop80">*/}
                    {/*            <div className="col-xs-12">*/}
                    {/*                <div className="text-center">*/}
                    {/*                    <Link to="/Frontend/Index/?i=1" className="btn btn-primary btn-lg">Comenzar la*/}
                    {/*                        compra</Link>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    )}*/}
                    {/*</div>*/}
                </>
            ) :
                (
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="our-selections">
                                <h3>Explora nuestros productos</h3>
                            </div>
                        </div>
                    </div>
                    <div className="row margintop60">
                        {products.filter(x => !x.EsDemo && x.Producto).map(item => {
                            return (
                                <div className="col-xs-12 col-sm-6 col-md-4" key={item.Id}>
                                    <div className="product-item relative">
                                        <Link to={PRODUCT_DETAIL_PATH + `/${item.Id}`} className="img-box">
                                            <img src={item.Producto.Archivos}
                                                 className="img-responsive img-producto-categoria"
                                                 alt="Foto de Categoría"/>
                                        </Link>
                                        <div className="footer-product">
                                            <Link to={PRODUCT_DETAIL_PATH + `/${item.Id}`}
                                                  className="h5 title-product show">{item.Producto.Nombre}</Link>
                                            {canAddProducts &&
                                                <AddProductToCartButton
                                                    productId={item.Id}
                                                    application={application}
                                                    navigator={navigator}
                                                    deliverySiteFeature={deliverySiteFeature}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                   </div>
                </div>
            ))
        }
        {/*    <div className="visible-xs menu-xs">*/}
        {/*        <div className="container">*/}
        {/*            <div className="row">*/}
        {/*                <Link to="/Frontend/IndexMobile">*/}
        {/*                    <div className="col-xs-6">*/}
        {/*                        <i className="pe-7s-plus icon-menu-xs"></i>*/}
        {/*                        <p className="title-menu-xs">Nuevo Pedido</p>*/}
        {/*                    </div>*/}
        {/*                </Link>*/}
        {/*                <Link to="/Frontend/RepetirPedido">*/}
        {/*                    <div className="col-xs-6">*/}
        {/*                        <i className="pe-7s-refresh-2 icon-menu-xs"></i>*/}
        {/*                        <p className="title-menu-xs">Repetir Pedido</p>*/}
        {/*                    </div>*/}
        {/*                </Link>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        <hr/>*/}
        {/*        <div className="submenu-xs">*/}
        {/*            <div className="container">*/}
        {/*                <div className="row">*/}
        {/*                    <Link to="/Frontend/RepetirPedido">*/}
        {/*                        <div className="col-xs-3">*/}
        {/*                            <i className="pe-7s-shopbag icon-menu-xs"></i>*/}
        {/*                            <p className="title-menu-xs truncate">Mis pedidos</p>*/}
        {/*                        </div>*/}
        {/*                    </Link>*/}
        {/*                    <Link to={ORDERS_MANAGEMENT_PATH}>*/}
        {/*                        <div className="col-xs-3">*/}
        {/*                            <i className="pe-7s-pen icon-menu-xs"></i>*/}
        {/*                            <p className="title-menu-xs truncate">Solicitudes</p>*/}
        {/*                        </div>*/}
        {/*                    </Link>*/}
        {/*                    <Link to="/Frontend/Favoritos">*/}
        {/*                        <div className="col-xs-3">*/}
        {/*                            <i className="pe-7s-like icon-menu-xs"></i>*/}
        {/*                            <p className="title-menu-xs truncate">Favoritos</p>*/}
        {/*                        </div>*/}
        {/*                    </Link>*/}
        {/*                    <Link to={PROFILE_PATH}>*/}
        {/*                        <div className="col-xs-3">*/}
        {/*                            <i className="pe-7s-user icon-menu-xs"></i>*/}
        {/*                            <p className="title-menu-xs truncate">Mi Perfil</p>*/}
        {/*                        </div>*/}
        {/*                    </Link>*/}
        {/*                </div>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*    <hr className="visible-xs marginbottom0"/>*/}
        {/*    <hr className="divider-line footer-line hidden-xs"/>*/}
        </div>
    );
};

export default observer(HomeContent);
